import { observable } from "mobx";
import React from "react";
import {montarSelectOption} from "../../../utils/formatar";

export default class FiltrosOswebStore {

    @observable statusFiltros;
    @observable situacoesFiltros;

    @observable situacaoSelcionado;
    @observable filtros;

    constructor(service) {
        this.situacoesFiltros = false;

        this.statusSelcionado = false;
        this.situacaoSelcionado = false;
        this.filtros = {
            os: null, doc: null
        };

        this.service = service;

        this.carregarFiltros();
    };

    carregarFiltros = () => {

        this.service.listarSituacoes().then(response => {
            if (response.data) {
                this.situacoesFiltros = montarSelectOption("RvMeaning", "RvMeaning", response.data, false); // Eles estão recebendo o dado de Rv Meaning, não de Id.RvLowValue
            }
        });
    };

    onChangeFiltro = (dado, event) => {
        if (event) {
            _.set(this.filtros, dado, event.target.value);
        } else {
            _.set(this.filtros, dado, null);
        }
    };

    onChangeFiltroSituacao = value => {
        this.situacaoSelcionado = value!==null ? value : false;
    };
}



// WEBPACK FOOTER //
// ./src/modules/osweb/stores/FiltrosOswebStore.js